import { Button, ButtonProps } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useSnackbar } from 'notistack';

interface Props extends Omit<ButtonProps, 'onClick'> {
  label?: string;
  onGenerate: () => void;
}

export const PdfPrintButton = ({ label = 'Tisk PDF', onGenerate, ...rest }: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  const handle = () => {
    try {
      onGenerate();
      enqueueSnackbar('PDF vygenerováno', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar('Chyba při generování PDF: ' + String(e), { variant: 'error' });
    }
  };
  return (
    <Button variant="outlined" startIcon={<PictureAsPdfIcon />} onClick={handle} {...rest}>
      {label}
    </Button>
  );
};
